import { useEffect } from 'react'
import { type IResponseIntegrationDisconnected } from 'entities/Integrations'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { IntegrationListStore } from 'pages/settings/pages/integrations/store/integrationListStore'
import type { IntegrationDetailsStore } from 'pages/settings/pages/integrations/store/integrationDetailsStore'

export const useEventIntegrationDisconnectedSettingsList = (
  integrationListStore: IntegrationListStore
) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseIntegrationDisconnected) => {
    integrationListStore.syncUserIntegration(data.userIntegration)
  }

  useEffect(() => websocket.on(WebsocketEvent.IntegrationDisconnected, handler), [])
}

export const useEventIntegrationDisconnectedSettingsDetails = (
  integrationDetailsStore: IntegrationDetailsStore
) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseIntegrationDisconnected) => {
    integrationDetailsStore.integration?.syncUserIntegration(data.userIntegration)
  }

  useEffect(() => websocket.on(WebsocketEvent.IntegrationDisconnected, handler), [])
}
